import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Slide from '@material-ui/core/Slide';
import styled from 'styled-components';
import { openDrawer as openCouseDrawer } from '../../course/courseActions';
import { openDrawer as openMergeCommandDrawer } from '../../mergeCommands/mergeCommandsActions';
import { removeAllCommandsIds } from '../commandsActions';

const CustomPaper = styled(Paper)`
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

/**
 * Element qui s'affiche uniquement lorsque des commandes sont sélectionné
 * il permet de faire une demande de coursier ou alors une demande de fusion
 * de commande
 *
 * @param {Array} checkedCommandsIds                Liste des commandes sélectionné
 * @param {Object} currentCourse                    Object représentant la course en cours, si elle existe
 * @param {Function} dispatchOpenCourseDrawer       Ouverture du drawer pour faire une demande de coursier
 * @param {Function} dispatchOpenMergeCommandDrawer Ouverture du drawer pour faire une fusion de commande
 * @param {Function} dispatchRemoveAllCommandsIds   Suppression de tous les id de commande selectionnés
 */
const SelectedCommands = ({
  checkedCommandsIds,
  currentCourse,
  dispatchOpenCourseDrawer,
  dispatchOpenMergeCommandDrawer,
  dispatchRemoveAllCommandsIds
}) => {
  /**
   * Supprime tous les id de commande sélectionner à l'initialisation du
   * composant, cela permet notament de ne pas avoir d'id de commande sélectionné
   * après l'import de commande
   */
  useEffect(
    () => () => {
      dispatchRemoveAllCommandsIds();
    },
    [dispatchRemoveAllCommandsIds]
  );
  return (
    <Slide
      direction="down"
      in={checkedCommandsIds.length > 0}
      mountOnEnter
      unmountOnExit
    >
      <CustomPaper>
        <span style={{ fontSize: '1.3em', fontWeight: 'bold' }}>
          {checkedCommandsIds.length} commande
          {checkedCommandsIds.length > 1 && 's'} sélectionée
          {checkedCommandsIds.length > 1 && 's'}
        </span>
        {checkedCommandsIds.length > 1 && (
          <Button
            variant="contained"
            color="primary"
            onClick={() => dispatchOpenMergeCommandDrawer()}
          >
            Fusionner les commandes
          </Button>
        )}
        <Button
          variant="contained"
          color="primary"
          onClick={() => dispatchOpenCourseDrawer({ allCommands: false })}
        >
          {currentCourse
            ? 'Ajouter à la course en cours'
            : 'Demander le traitement'}
        </Button>
      </CustomPaper>
    </Slide>
  );
};

const mapStateToProps = state => ({
  checkedCommandsIds: state.commands.checkedCommandsIds,
  numberOfCommands: state.commands.numberOfCommands,
  currentCourse: state.init.currentCourse
});

const mapDispatchToProps = dispatch => ({
  dispatchOpenCourseDrawer: params => dispatch(openCouseDrawer(params)),
  dispatchOpenMergeCommandDrawer: () => dispatch(openMergeCommandDrawer()),
  dispatchRemoveAllCommandsIds: () => dispatch(removeAllCommandsIds())
});

SelectedCommands.propTypes = {
  checkedCommandsIds: PropTypes.array.isRequired,
  dispatchOpenCourseDrawer: PropTypes.func.isRequired,
  dispatchOpenMergeCommandDrawer: PropTypes.func.isRequired,
  dispatchRemoveAllCommandsIds: PropTypes.func.isRequired,
  currentCourse: PropTypes.object
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectedCommands);
